module.exports = __webpack_public_path__ + "static/media/main_small_1.06b18904.png";